import { atom } from "recoil";

export const vassViewState = atom({
  key: "vassViewState",
  default: '1',
});
